// Querys and Mutations
import {
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE,
  GET_ALL,
  VALIDATE_LUNCH
} from '@/graphql/dailyControl/LunchControlGraphql'

// models
import { ResponseDefault, Paginator, ResponseCustom } from '@/models'
import {
  LunchControlModel,
  LunchControlsWithPagination,
  LunchControlForm,
  FiltersLunchControl
} from '@/models/dailyControl'

// apollo
import { apolloClient } from '@/apollo'
import { getFirstErrorApollo } from '@/utils/apollo'

const filtersDefault: FiltersLunchControl = {
    dateEnd: null,
    dateStart: null,
    employee: null
}

class LunchControlsService {
  /**
   * Queries
   */
  async getWithPagination (perPage = 10, page = 1, filters: FiltersLunchControl): Promise<LunchControlsWithPagination> {
      const result = await apolloClient.query({
          query: GET_WITH_PAGINATION,
          variables: {
            page: page,
            perPage: perPage,
            filters: {
                dateStart: filters.dateStart ?? null,
                dateEnd: filters.dateEnd ?? null,
                employee: filters.employee ? filters.employee : null
            }
          }
      })
      const pagination: Paginator = result.data.lunchControlsWithPagination.paginatorInfo
      const data: [LunchControlModel] = result.data.lunchControlsWithPagination.data
      const response: LunchControlsWithPagination = {
          objects: data,
          pagination: pagination
      }
      return response
  }

  async getAll (filters: FiltersLunchControl = filtersDefault): Promise<LunchControlModel[]> {
      const result = await apolloClient.query({
          query: GET_ALL,
          variables: {
              filters: {
                dateStart: filters.dateStart ?? null,
                dateEnd: filters.dateEnd ?? null,
                employee: filters.employee ? filters.employee : null
            }
          }
      })
      return result.data.lunchControls
  }

  /**
   * Mutations
   */
    create (form: LunchControlForm): Promise<ResponseCustom> {
        return apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        }).then(() => {
            return {
                success: true,
                msg: 'success'
            }
        }).catch(e => {
            throw getFirstErrorApollo(e)
        })
    }

  update (id: number, form: LunchControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
        mutation: UPDATE,
        variables: {
            id: id,
            input: form
        }
    }).then(() => {
        return {
            success: true,
            msg: 'success'
        }
    }).catch(e => {
        throw getFirstErrorApollo(e)
    })
  }

  async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
  }

  async validateLunch (id: number|null, form: LunchControlForm): Promise<ResponseCustom> {
        return apolloClient.mutate({
            mutation: VALIDATE_LUNCH,
            variables: {
                id: id,
                input: form
            }
        }).then(res => {
            return {
                success: res.data.validateLunchControl.success,
                msg: res.data.validateLunchControl.msgError
            }
        }).catch(e => {
            throw getFirstErrorApollo(e)
        })
    }
}

export default new LunchControlsService()
